/* eslint-disable camelcase */
import { Component } from "react";
import $ from "jquery";
import queryString from "query-string";
import PhoneInput from "react-phone-number-input";
import { connect } from "react-redux";
import { Segment, Button, Form, Message } from "semantic-ui-react";
import styled from "styled-components";

import { getMetaContent } from "../../Common/helpers/meta";
import { identifyNamedPathFromUrl } from "../../Common/helpers/utils";
import managerOnboardingText from "../helpers";

import FormError from "./FormError";
import { TextInput, HeaderText } from "./Login";

const PasswordSegment = styled.div`
  display: flex;
  flex-flow: column nowrap;

  .password {
    margin: 0 !important;
    order: 2;
    > .ui.fluid.input {
      margin-bottom: 0 !important;
    }
  }
`;

class Registration extends Component {
  state = {
    user: {
      first_name: "",
      last_name: "",
      email: "",
      password: "",
      password_confirmation: "",
      phone_number: "",
    },
    loading: false,
    initialLoad: true,
    error: "",
    errors: {},
    responsibilities: [],
  };

  componentDidMount() {
    this.collectDataFromToken();
  }

  collectDataFromToken = () => {
    const { reset_password_token, redirect_url } = queryString.parse(
      this.props.location.search
    );

    if (!reset_password_token) {
      return this.setState({ invalidSetupUrl: true, initialLoad: false });
    }

    return $.ajax({
      url: "/users/password/edit",
      type: "GET",
      dataType: "json",
      data: { reset_password_token, redirect_url },
    })
      .then(
        ({
          email,
          last_name,
          first_name,
          phone_number,
          user_root_path,
          pending_setup,
          responsibilities,
        }) => {
          const parsedUrl = queryString.parse(this.props.location.search);
          // Delete the redirectUrl query params so we do not include this when redirecting later
          delete parsedUrl.redirect_url;
          const redirectLocation = redirect_url
            ? `${redirect_url}?${queryString.stringify(parsedUrl)}`
            : user_root_path;

          if (!pending_setup) {
            return (window.location.href = redirectLocation);
          }

          const { user } = this.state;
          user.email = email;
          user.first_name = first_name || "";
          user.last_name = last_name || "";
          user.phone_number = phone_number || "";

          this.setState({
            error: "",
            user,
            initialLoad: false,
            redirectLocation,
            responsibilities,
          });
        }
      )
      .catch(() => {
        this.setState({ invalidSetupUrl: true, initialLoad: false });
      });
  };

  handleInputChange = (e) => {
    const { user, errors } = this.state;
    user[e.target.name] = e.target.value;
    if (e.target.name === "password_confirmation") {
      errors.password = [];
    } else {
      errors[e.target.name] = [];
    }
    this.setState({ user, errors });
  };

  handleSubmit = (event, userCredentials) => {
    event.preventDefault();
    this.setState({ loading: true });
    const csrfToken = getMetaContent("csrf-token");

    const { reset_password_token } = queryString.parse(
      this.props.location.search
    );

    return $.ajax({
      url: "/user_account_update",
      type: "PUT",
      dataType: "json",
      data: { user: { ...userCredentials }, token: reset_password_token },
      beforeSend: (request) =>
        request.setRequestHeader("X-CSRF-Token", csrfToken),
      success: () => {
        this.setState({ error: [], loading: false });
        window.location.href = this.state.redirectLocation;
      },
      error: (xhr) => {
        const error = [];
        const { errors } = JSON.parse(xhr.responseText);

        if (typeof errors === "string") {
          error.push(errors);
        } else {
          const { password, password_confirmation, first_name, last_name } =
            errors;
          first_name &&
            first_name.map((err) => error.push(`First name ${err}`));
          last_name && last_name.map((err) => error.push(`Last name ${err}`));
          password &&
            password.map((err) =>
              err.match(/passwords/gi)
                ? error.push(err)
                : error.push(`Password ${err}`)
            );
          password_confirmation &&
            password_confirmation.map((err) =>
              error.push(`Password confirmation ${err}`)
            );
        }

        this.setState({
          loading: false,
          error,
          errors,
        });
      },
    });
  };

  validateFormField = () => {
    return Object.keys(this.state.user)
      .filter((k) => k !== "phone_number")
      .some((k) => this.state.user[k].trim().length === 0);
  };

  setupContextText = (email = null) => {
    const { responsibilities } = this.state;
    const { redirect_url } = queryString.parse(this.props.location.search);
    const namedPath = identifyNamedPathFromUrl(redirect_url);

    switch (namedPath) {
      case "jobs_onboarding":
      case "candidates_offers":
        return `To continue, first set up your account for ${email}`;
      default:
        return managerOnboardingText(responsibilities, email);
    }
  };

  render() {
    const {
      user: {
        last_name,
        first_name,
        password,
        password_confirmation,
        phone_number,
        email,
      },
      error,
      errors,
      loading,
      invalidSetupUrl,
    } = this.state;
    const { flashMessage } = this.props;
    const setupTextContext = this.setupContextText(email);

    if (this.state.initialLoad) {
      return (
        <Segment className="login forgot-password">
          <p>Loading...</p>
        </Segment>
      );
    }

    if (invalidSetupUrl) {
      return (
        <Segment className="login forgot-password">
          <HeaderText textAlign="center" as="h2">
            Welcome to HireArt.
          </HeaderText>
          <p>This account registration link is invalid or has expired.</p>
        </Segment>
      );
    }

    return (
      <Segment className="login employer-registration">
        <HeaderText textAlign="center" as="h2">
          Welcome to HireArt.
        </HeaderText>
        <p className="subhead-text">{setupTextContext}</p>

        {!error.length &&
          flashMessage &&
          flashMessage.length > 0 &&
          !loading && <Message color="yellow">{flashMessage}</Message>}

        <FormError error={error} />

        <Form onSubmit={(e) => this.handleSubmit(e, this.state.user)}>
          <Form.Input
            tabIndex="1"
            control={TextInput}
            value={first_name}
            onChange={this.handleInputChange}
            name="first_name"
            placeholder="First name"
            error={errors.first_name && errors.first_name.length > 0}
            autoFocus={first_name.length === 0}
            fluid
          />

          <Form.Input
            tabIndex="2"
            control={TextInput}
            value={last_name}
            onChange={this.handleInputChange}
            name="last_name"
            error={errors.last_name && errors.last_name.length > 0}
            placeholder="Last name"
            fluid
          />

          <PasswordSegment>
            <Form.Input
              tabIndex="4"
              control={TextInput}
              value={password}
              onChange={this.handleInputChange}
              name="password"
              type="password"
              placeholder="Create password"
              error={errors.password && errors.password.length > 0}
              fluid
              className="password"
              autoFocus={phone_number.length > 0}
            />

            <PhoneInput
              tabIndex="3"
              country="US"
              autoComplete="tel"
              type="tel"
              showCountrySelect={false}
              value={phone_number}
              onChange={(phone_number) => {
                const { user } = this.state;
                user.phone_number = phone_number || "";
                this.setState({ user });
              }}
              name="phone_number"
              placeholder="Phone number (optional)"
              autoFocus={phone_number.length == 0 && first_name.length > 0}
            />
          </PasswordSegment>
          <input
            tabIndex="-1"
            onChange={() => {}}
            name="email"
            type="email"
            value={email}
            readOnly
            hidden
          />

          <Form.Input
            tabIndex="5"
            control={TextInput}
            value={password_confirmation}
            onChange={this.handleInputChange}
            name="password_confirmation"
            type="password"
            placeholder="Confirm password"
            error={errors.password && errors.password.length > 0}
            fluid
          />

          <Button
            loading={loading}
            type="submit"
            fluid
            className="primary"
            disabled={this.validateFormField() || loading}
          >
            Create my account
          </Button>
        </Form>
      </Segment>
    );
  }
}

const mapDispatchToProps = ({ session: { flash } }) => ({
  flashMessage: flash,
});

export default connect(mapDispatchToProps)(Registration);
